import { FormRadioGroup } from './FormRadioGroup'
import { RadioGroup } from './RadioGroup'

export { FormRadioGroup as FormRadio, RadioGroup as Radio }
